import { render, staticRenderFns } from "./StaticImage.vue?vue&type=template&id=6b0b9499"
import script from "./StaticImage.vue?vue&type=script&lang=js"
export * from "./StaticImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports